/**
 * Krok B1 — PREDVYPLNENI PRUVODCE Z ODKAZU NA INZERAT.
 *
 * Klient jen zavola API a dostane NAVRH hodnot. Nic nezaklada a nic nevi
 * o portalech: ktery odkaz jde nacist a ktery ne, rozhoduje registr zdroju
 * na serveru (`SOURCE-REGISTRY.yaml`) a robots.txt cizi domeny.
 */

import type { ApiPaths } from '@reos/api-client';
import { apiClient } from './api.js';
import { unwrap } from './api-error.js';

export type ListingPrefillDto =
  ApiPaths['/v1/duediligence/listing-prefill']['post']['responses']['200']['content']['application/json'];

export async function fetchListingPrefill(url: string): Promise<ListingPrefillDto> {
  return unwrap(apiClient.POST('/v1/duediligence/listing-prefill', { body: { url } }));
}
